export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    sortable: false,
    sortField: 'name',
    label: 'field.name',
    stickyColumn: true,
    variant: 'light',
    tdClass: 'limit-size',
  },
  {
    key: 'username',
    sortable: false,
    sortField: 'username',
    label: 'field.username',
  },
  {
    key: 'commissionBalance',
    sortable: false,
    sortField: '',
    label: 'field.commissionBalance',
    tdClass: 'text-right',
  },
  {
    key: 'receiveCommission',
    sortable: false,
    sortField: '',
    label: 'field.receiveCommission',
    tdClass: 'text-right',
  },
  {
    key: 'claimCommission',
    sortable: false,
    sortField: '',
    label: 'field.claimCommission',
    tdClass: 'text-right',
  },
  {
    key: 'balance',
    sortable: false,
    sortField: '',
    label: 'field.availableCredit',
    tdClass: 'text-right',
  },
]
